module.exports = __webpack_public_path__ + "media/images/application/template/logo--schema-f6948756fd3f889c40e398d4bbc15aad.png";